import React, { useState } from 'react';

import { PageContainer } from 'components';
import * as createPrsStore from 'store/post-results-services/prsSlice';
import { ScopedExtroProvider } from 'components/extro/ScopedExtroProvider';

import { Stepper } from '@britishcouncil/react-extro-ui';

import { useAppDispatch } from '../../store/hooks';

import { CreatePRSStep2Fields, Step2 } from './steps/Step2';
import { CreatePRSStep1Fields, Step1 } from './steps/Step1';
import * as S from './CreatePostResultsService.style';
const steps = ['Provide details', 'Terms & conditions', 'Step 3'];

type CreatePRSStep1FieldsFull = {
  [K in keyof CreatePRSStep1Fields]: NonNullable<CreatePRSStep1Fields[K]>;
};

const step1InitialValues = {
  sessionId: 0,
  candidateId: 0,
  serviceTypeId: 0,
  registrationId: 0,
  countryId: 0,
  components: [],
  isPrsConsent: false,
};

const step2InitialValues = {
  tncAccepted: false,
};

export const CreatePostResultsService = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const dispatch = useAppDispatch();
  const [step1Value, setStep1Value] = useState<CreatePRSStep1Fields>(step1InitialValues);
  const [step2Value, setStep2Value] = useState<CreatePRSStep2Fields>(step2InitialValues);

  const handleSelectedComponents = (data: CreatePRSStep1FieldsFull) => {
    setStep1Value(data);
    dispatch(createPrsStore.setComponents(data));
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleSelectedTC = (data: CreatePRSStep2Fields) => {
    setStep2Value(data);
    dispatch(createPrsStore.setTc(data));
  };

  const handleBackFromTc = (data: CreatePRSStep2Fields) => {
    setStep2Value(data);
    setCurrentStep((prevStep) => prevStep - 1);
  };

  return (
    <S.StyledPageContainer>
      <PageContainer>
        <S.Header>
          <span>Create request</span>
        </S.Header>
        <ScopedExtroProvider>
          <S.StyledWarningMessage
            variant="warning"
            background="#e7f0f7"
            color="#23085a"
            header="The following information explains what may happen when you apply for Enquiries about Results and your papers are remarked."
          >
            <ol>
              <li>Your original mark is confirmed as correct and there is no change to your grade.</li>
              <li>
                Your original mark is lowered and as a result your final grade may be lower than the original grade you
                received.
              </li>
              <li>
                Your original mark is raised and as a result your final grade may be higher than the original grade you
                received.
              </li>
            </ol>
          </S.StyledWarningMessage>
          <Stepper steps={steps} activeStepIndex={currentStep} />

          <S.ContentWrapper>
            {currentStep === 0 && <Step1 initialValues={step1Value} onNext={handleSelectedComponents} />}
            {currentStep === 1 && (
              <Step2 initialValues={step2Value} onNext={handleSelectedTC} onBack={handleBackFromTc} />
            )}
          </S.ContentWrapper>
        </ScopedExtroProvider>
      </PageContainer>
    </S.StyledPageContainer>
  );
};
